'use client';
import { useState, useEffect, memo } from 'react';

import styled from 'styled-components';
import { usePathname } from 'next/navigation';

import Header from '@components/ui/headers/Header/Header';
import { HeaderViewModel } from '@api/v3';
import { useDevice } from '@contexts/device';
import GeneralLoader from '@components/ui/GeneralLoader';

const TransparentWrapper = styled.div`
  position: fixed;
  width: 100vw;
  top: 0;
  z-index: 800;
  transition: all 0.5s ease-in;
  display: block;
`;
const Wrapper = styled.div`
  position: relative;
  width: 100vw;
  top: 0;
  z-index: 800;
  transition: all 0.5s ease-in;
  display: block;
`;
const StickyWrapper = styled.div`
  position: fixed;
  width: 100vw;
  top: 0;
  z-index: 800;
  transition: all 0.5s ease-in;
  display: block;
`;
const HomeHeader = ({
  data,
  isNotHomepage,
}: {
  data?: HeaderViewModel;
  isNotHomepage?: boolean;
}) => {
  const [showHeader, setShowHeader] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowHeader(window.scrollY === 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const { isDesktop } = useDevice();
  const pathname = usePathname();

  const [isRouteLoading, setIsRouteLoading] = useState(false);

  useEffect(() => {
    setIsRouteLoading(true);
    const timeout = setTimeout(() => {
      setIsRouteLoading(false);
    }, 500);
    setIsLoading(false);
    return () => clearTimeout(timeout);
  }, [pathname]);
  return isDesktop ? (
    <>
      <>
        {isNotHomepage ? (
          <Wrapper>
            <Header
              setIsLoading={setIsLoading}
              isLoading={isLoading}
              isHomepage={true}
              data={data}
            />
            <div id='header_reserve' />
          </Wrapper>
        ) : (
          <>
            {!showHeader ? (
              <TransparentWrapper>
                <Header
                  setIsLoading={setIsLoading}
                  isLoading={isLoading}
                  isHomepage={true}
                  data={data}
                />
                <div id='header_reserve' />
              </TransparentWrapper>
            ) : (
              <StickyWrapper>
                <Header
                  setIsLoading={setIsLoading}
                  isLoading={isLoading}
                  isHomepage={true}
                  data={data}
                />
                <div id='header_reserve' />
              </StickyWrapper>
            )}
          </>
        )}
      </>

      {isLoading || isRouteLoading ? <GeneralLoader /> : null}
    </>
  ) : (
    <>
      {isNotHomepage ? (
        <>
          <Header
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            isHomepage={true}
            data={data}
          />
          <div id='header_reserve' />
        </>
      ) : (
        <TransparentWrapper>
          <Header
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            isHomepage={true}
            data={data}
          />
          <div id='header_reserve' />
        </TransparentWrapper>
      )}

      {isLoading || isRouteLoading ? <GeneralLoader /> : null}
    </>
  );
};
export default memo(HomeHeader);
